/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

export const GLOBAL_ADMIN_OVERVIEW_REQUEST = "GLOBAL_ADMIN_OVERVIEW_REQUEST";
export const GLOBAL_ADMIN_OVERVIEW_SUCCESS = "GLOBAL_ADMIN_OVERVIEW_SUCCESS";
export const GLOBAL_ADMIN_OVERVIEW_FAILURE = "GLOBAL_ADMIN_OVERVIEW_FAILURE";

export const FETCH_OVER_VIEW_DETAILS_REQUEST =
  "FETCH_OVER_VIEW_DETAILS_REQUEST";
export const FETCH_OVER_VIEW_DETAILS_SUCCESS =
  "FETCH_OVER_VIEW_DETAILS_SUCCESS";
export const FETCH_OVER_VIEW_DETAILS_FAILURE =
  "FETCH_OVER_VIEW_DETAILS_FAILURE";
export const FETCH_OVER_VIEW_DETAILS_DOWNLOAD_REQUEST =
  "FETCH_OVER_VIEW_DETAILS_DOWNLOAD_REQUEST";
export const FETCH_OVER_VIEW_DETAILS_DOWNLOAD_SUCCESS =
  "FETCH_OVER_VIEW_DETAILS_DOWNLOAD_SUCCESS";
export const FETCH_OVER_VIEW_DETAILS_DOWNLOAD_FAILURE =
  "FETCH_OVER_VIEW_DETAILS_DOWNLOAD_FAILURE";
export const FETCH_GLOBAL_ADMIN_DOWNLOAD_SUCCESS =
  "FETCH_GLOBAL_ADMIN_DOWNLOAD_SUCCESS";
